export const UI_ROUTES = {
  dashboard: '/',
  login: 'login',
  signup: 'register',
  signupDsa: 'register/dsa',
  verifyEmailWithToken: 'verify-email',
  loanApplicationForm: 'loan-application-form',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password/:token',
  finance: 'finance',
  premiumPartners: 'PremiumPartners',
  EpcPartners: 'epc-partners',
  EpcRewards: 'epc-rewards',
  cookiePolicy: 'policies/cookie',
  EPC: 'epc-onboarding',
  DSA: 'dsa',
  aboutUs: 'about-us',
  campaignshowcase: 'ad-campaigns',
  solarCalculator: 'solar-calculator',
  mySavings: 'my-solar-saving',
  residentialLoan: 'loan-products/residential',
  residentialRooftopLoan: 'loan-products/residential-rooftop',
  residentialLoanContact: 'loan-products/residential/contact',
  commercialAndIndustrialLoan: 'loan-products/commercial-and-industrial',
  housingSocietyLoan: 'loan-products/housing-society',
  knowledge: 'knowledge',
  privacyPolicy: 'privacy-policy',
  solfinPrivacyPolicy: 'policies/privacy-policy',
  refundPolicy: 'policies/refund-and-cancellation-policy',
  solfinFairPracticeCodePolicy: 'policies/fair-code-practice',
  solfinGrievanceRedressalPolicy: 'policies/grievance-redressal-policy',
  termsAndConditions: 'policies/terms-and-conditions',
  distributorJoin: 'distributor/join',
  registrationComplete: 'RegistrationComplete',
  custRegistrationComplete: 'cust-registration-complete',
  custRegistered: 'cust-registered',
  partnerRegistrationComplete: 'PartnerRegistrationComplete',
  lease: 'lease',
  comingSoon: 'coming-soon',
  mission: 'mission',
  contactSales: 'contact-sales',
  contactUs: 'contact-us',
  leaseContact: '/solar-finance-lease',
  sitemap: 'sitemap',
  internalLogin: 'internal-login',
  waareeDealerSurvey: 'survey/waaree-dealer',
  redirect: 's/:shortCode',
  admin: {
    leadsEPC: '/epc-leads',
    financeApplications: '/finance-applications',
    leadsEPCDetails: '/epc-leads/detail/:id',
    nonFinanceApplications: '/non-finance-applications',
    nonFinanceApplicationDetails: '/non-finance-applications/:id/details',
    financeApplicationDetails: '/finance-applications/:id/details',
    allLeads: '/all-leads',
    leadDetails: '/all-leads/detail/:leadCode',
    customers: '/customers',
    customersDetails: '/customers/details/:id',
    loans: '/loans',
    loansDetails: '/loans/details/:loanCode',
    epcApplicants: '/epc-applicants',
    epcApplicantsDetails: '/epc-applicants/epc-applicants-detail/:id',
    epcEmpanelled: '/epc-empanelled',
    epcRejected: '/epc-rejected',
    epcEmpanelledDetail: '/epc-empanelled/detail/:id',
    epcRejectedDetail: '/epc-rejected/detail/:id',
    distributorLeads: '/distributor-leads',
    distributorKyc: '/distributor/kyc',
    distributorKycDetail: '/distributor-applicants/kyc-detail/:id',
    createEmpanelledForm: '/distributor-applicants/dynamic-form/:userCode',
    distributorCreditRating: '/distributor/credit-rating',
    distributorEmpanelled: '/distributor-onboarded',
    distributorOpsReview: '/distributor/ops-review',
    distributorEmpanelledApplicationDetails:
      '/distributor-applicants/credit-check/:id',
    distributorRejected: '/distributor-rejected',
    dsaApplicants: '/dsa-applicants',
    dsaApplicantsDetail: '/dsa-applicants/detail/:id',
    dsaEmpanelled: '/dsa-empanelled',
    dsaEmpanelledDetail: '/dsa-empanelled/detail/:id',
    invoicesPending: '/channelFinancing/invoices/pending',
    invoicesVerified: '/channelFinancing/invoices/verified',
    projects: '/projects',
    projectsDetail: '/project/detail/:id',
    // supportTickets: '/support-tickets',
    // supportTicketDetails: '/support-tickets/details/:loanId',
    // userRole: '/user-role',
    pllAllLeads: '/pll/all-leads',
    pllCalculator: '/pll/calculator'
  },
  manufacturer: {
    dashboard: '/dashboard',
    epcEmpanelled: '/epc-empanelled',
    epcLeads: '/epc-leads/:epcId',
    distributorEmpanelled: '/distributor-empanelled'
  },
  NOTFound: '404',
  epc: {
    profile: '/profile',
    dashboard: '/dashboard',
    referredLead: '/referred-leads/:leadType',
    assignedApplications: '/assigned-leads',
    assignedApplicationDetails: '/assigned-leads/details/:code',
    addQuoteById: '/assigned-leads/add-quote/:id',
    rateMatrix: '/rate-matrix',
    projects: '/projects',
    referredLeadDetails: '/referred-leads/:leadType/detail/:leadCode',
    projectDetailById: '/projects/:id/details',
    loans: '/loans',
    loanDetailById: '/loans/:id/details'
  },
  customer: {
    home: '/home',
    applicationTracking: '/application-tracking/:applicationCode',
    applicationLoanDisbursal: '/application-loan-disbursal/:applicationCode',
    support: '/support',
    profile: '/profile',
    documents: '/documents',
    registrationComplete: '/registration-complete',
    repaymentSchedule:
      '/application-loan-disbursal/:applicationCode/repayment-schedule'
    /*
    * As these routes are the part of previous implementation,
    * So commenting them as per new implementations
    * 
    applications: '/applications',
    applicationDetailsById: '/application/:id/details',
    newApplication: '/new-application',
    projects: '/projects',
    projectDetailById: '/project/:id/details',
    monitoring: '/monitoring',
    changePassword: '/change-password',
    loans: '/loans',
    loanDetailById: '/loan/:id/details',
    loanApplicationForCI: '/loan-application/:id',
     */
  },
  dsa: {
    onboarding: '/',
    dashboard: '/dashboard',
    myLeads: '/my-leads',
    projects: '/projects',
    leadsDetail: '/leads-detail/:id'
  },
  distributor: {
    dashboard: '/dashboard',
    pendingInvoices: '/pending-invoices',
    verifiedInvoices: '/verified-invoices',
    loanSummary: '/loan-summary',
    loans: '/loans',
    loanDetailById: '/loans/:id/details',
    viewSharedLoanApplication: '/view-shared-loan-application',
    distributorJoin: '/join'
  }
};
